module.exports = __webpack_public_path__ + "img/skype.3e2936ee.svg";